import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'gatsby-link';
import { Button as FBLoginBtn } from '@tusken-s/facebook-tools';
import Key from '../../assets/images/logo/key.svg';
import Profile from '../../assets/images/logo/profile.svg';
import { loginFacebook, logout, signIn } from '../../actions/loginAction';
import { Alert, Modal, ModalBody } from 'reactstrap';

class AuthModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
      error: false,
    };
    this.toggle = this.toggle.bind(this);
    this.responseFacebook = this.responseFacebook.bind(this);
  }

  toggle() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => this.props.ToggleModal()
    );
  }

  goToLogin() {
    this.props.loginFacebook(
      this.state.AccessToken,
      () => {
        this.toggle();
      },
      () => {
        this.setState({
          errorLogin: true,
        });
      }
    );
  }

  FormAuth(e) {
    e.preventDefault();
    this.props.signIn(
      document.getElementById('username').value,
      document.getElementById('password').value,
      () => {
        this.toggle();
      },
      () =>
        this.setState({
          errorLogin: true,
        })
    );
  }

  responseFacebook(response) {
    this.setState(
      {
        AccessToken: response.accessToken,
      },
      () => {
        this.goToLogin();
      }
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className="txt-white pt-x"
        external={
          <button className="close" style={{ position: 'absolute', top: 25, right: 25, color: 'white' }}>
            <span className="fas fa-times" />
          </button>
        }
      >
        <ModalBody>
          <div className="pt-3 pb-3 text-center">
            <form className="row mb-3" onSubmit={e => this.FormAuth(e)}>
              <h2 className="col-12 text-center mb-5">Authentification</h2>
              <div className="col-12 mb-3 row">
                <img className="col-2" src={Profile} style={{ height: 20, marginTop: 15 }} />
                <input id="username" className="input-login col-10" placeholder="E-mail" name="Email" type="email" required />
              </div>
              <div className="col-12 mb-3 row">
                <img className="col-2" src={Key} style={{ height: 20, marginTop: 15 }} />
                <input
                  id="password"
                  className="input-login col-10 mb-3"
                  placeholder="Password"
                  name="Password"
                  type="password"
                  required
                />
              </div>
              <div className="col-12 row">
                <div className="offset-2" />
                <button className="btn-custom btn-silver col-4" type="submit" name="login">
                  Se connecter
                </button>
                <div className="offset-1" />
                <Link to={'/login'} className="btn-custom btn-purple col-4">
                  S'inscrire
                </Link>
              </div>
            </form>
            <div className="row" hidden={!this.state.errorLogin}>
              <Alert color="danger" className="offset-2 col-8">
                L'email ou le mot de passe entré est incorrect.
              </Alert>
            </div>
            <div className="row text-center" style={{ height: 50, justifyContent: 'between' }}>
              <div className="col-12 text-center">Ou</div>
            </div>
            <FBLoginBtn scope="public_profile,email" callback={this.responseFacebook} />
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = store => {
  return {
    token: store.login.token,
    user: store.login.user,
  };
};
export default connect(mapStateToProps, { loginFacebook, signIn, logout })(AuthModal);



// WEBPACK FOOTER //
// ./src/components/Modals/AuthModal.jsx